import { motion } from "framer-motion";
import { SectionHeading } from "@/components/SectionHeading";
import { viewportOnce } from "@/lib/motion";
import { PROCESS_STEPS } from "@/data/content";

const ProcessSection = () => {
  return (
    <section className="relative py-24 sm:py-32 bg-[#0F172A] overflow-hidden" id="process" data-testid="process-section">
      <div className="absolute inset-0 bg-grid-dark opacity-30" />
      <div className="absolute top-1/2 left-0 w-72 h-72 rounded-full bg-[#1E40AF] blur-[140px] opacity-30" />
      <div className="relative max-w-[1320px] mx-auto px-5 sm:px-8">
        <SectionHeading
          light
          align="center"
          overline="How We Work"
          title="Our Certification Process"
          description="A clear, seven-step path from first consultation to compliant market launch."
          className="mb-20"
        />

        <div className="relative">
          {/* Animated connecting line (desktop) */}
          <div className="hidden lg:block absolute top-9 left-0 right-0 h-px bg-white/10">
            <motion.div
              className="h-full bg-gradient-to-r from-[#2563EB] via-[#2563EB] to-[#16A34A] origin-left"
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.6, ease: "easeInOut" }}
            />
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-x-6 gap-y-12">
            {PROCESS_STEPS.map((step, i) => (
              <motion.div
                key={step.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={viewportOnce}
                transition={{ duration: 0.5, delay: i * 0.12 }}
                className="relative flex flex-col items-center text-center"
                data-testid={`process-step-${i + 1}`}
              >
                <div className="relative z-10 flex items-center justify-center w-[72px] h-[72px] rounded-2xl bg-[#1E40AF] text-white shadow-lg shadow-blue-900/40 ring-4 ring-[#0F172A]">
                  <step.icon className="w-7 h-7" strokeWidth={1.6} />
                  <span className="absolute -top-2 -right-2 flex items-center justify-center w-6 h-6 rounded-full bg-white text-[#1E40AF] text-xs font-bold shadow">
                    {i + 1}
                  </span>
                </div>
                <h3 className="mt-5 font-display font-semibold text-white text-sm sm:text-base leading-snug">{step.title}</h3>
                <p className="mt-2 text-xs text-slate-400 leading-relaxed max-w-[160px]">{step.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
